import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '../../components/layout/breadcrumbs';
import ModalQuestion from '../../components/modal-question';
import Page from '../../components/page';
import Question from '../../components/single-question';
import QuestionSkeleton from '../../components/question-skeleton';
import { api } from '../../providers/apiClient';
import { ContextUser } from '../../providers/ContextUser';
import { ContextSearch } from '../../providers/ContextSearch';
import InfoData from '../../components/info-data';
import Search from '../../components/search';
import NoResults from '../../components/no-result';
import { applyTextFilters, hasActiveFilters } from '../../utils';

const PageDepartment = ({ isCollapsed }) => {
  const { handleUpdateCurrentOrganization } = useContext(ContextUser);
  const { searchValues, setSearchValues } = useContext(ContextSearch);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const { departmentId } = useParams();
  const handleToggleModal = () => {
    if (isModalOpened) {
      setActiveQuestion(null);
    }
    setIsModalOpened((value) => !value);
  };
  const [questions, setQuestions] = useState([]);
  const [department, setDepartment] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [searchQuestionResult, setSearchQuestionResult] = useState([]);



  // Função para aplicar filtros localmente sem chamar API
  const applyFiltersLocally = (allQuestions, filters) => {
    const searchFields = [
      'question_details.short_description',
      'question_details.detail_description',
      'question_details.activity_description',
      'question_details.action_help'
    ];
    applyTextFilters(allQuestions, filters, searchFields, setSearchQuestionResult);
  };

  const fetchQuestions = async () => {
    try {
      setIsFetching(true);
      
      const response = await api.get(`/departments/${departmentId}/questions`);
      const data = response.data;
      
      // Atualiza estados
      setDepartment(data);
      setQuestions(data.questions);
      setBreadcrumbs(data.breadcrumbs);
      handleUpdateCurrentOrganization(data.organization);
      
                              // Aplica filtros salvos após carregar dados
        applyFiltersLocally(data.questions, searchValues['dep'] || {});
      
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setIsFetching(false);
    }
  };

  // Carrega dados apenas uma vez na montagem do componente
  useEffect(() => {
    fetchQuestions();
  }, []); // Sem dependências - executa apenas uma vez

  // Aplica filtros localmente quando searchValues mudar
  useEffect(() => {
    if (questions.length > 0) {
      if (hasActiveFilters(searchValues, 'dep')) {
        applyFiltersLocally(questions, searchValues['dep']);
      } else {
        // Se não há filtros ativos, mostra todas as questões
        setSearchQuestionResult(questions);
      }
    }
  }, [searchValues, questions]);

  // Recarrega dados quando modal fecha (para atualizações)
  useEffect(() => {
    if (!isModalOpened) {
      fetchQuestions();
    }
  }, [isModalOpened]);

  return (
    <>
      <Breadcrumbs id='breadcrumbs-department' path={breadcrumbs} />
      <Page id='page-department' title={department && department.name}>
        <InfoData
          id='department-info-data'
          compliance={department?.compliance}
          riskMatrix={department?.riskMatrix}
        />
        <Search
          id='search-department'
          data={questions}
          fields={[
            'question_details.short_description',
            'question_details.detail_description',
            'question_details.activity_description',
            'question_details.action_help',
          ]}
          placeholder='Busque por questões...'
          setSearchResult={setSearchQuestionResult}
          onSearchTextChange={setSearchValues}
          pageName='dep'
        />
        <div style={{ display: 'block', marginTop: '20px' }}>
          <Row id='department-questions-grid' style={{ width: '100%' }} className="g-3">
            {isFetching ? (
              [0, 1, 2, 3].map((item) => (
                <Col id={`skeleton-question-${item}`} md={12} key={`skeleton-${item}`}>
                  <QuestionSkeleton id={`skeleton-question-${item}`} />
                </Col>
              ))
            ) : searchQuestionResult.length > 0 ? (
            searchQuestionResult.map((item) => (
              <Col
                id={`question-card-${item.id}`}
                md={12}
                key={item.id}
                onClick={() => {
                  setActiveQuestion(item);
                  handleToggleModal();
                }}
              >
                <Question item={item} />
              </Col>
            ))
            ) : (
              <NoResults
                id='no-results-department'
                message='Nenhuma questão encrontrada'
                searchText={searchValues['dep']?.text || ''}
              />
            )}
          </Row>
        </div>
        {activeQuestion && (
          <ModalQuestion
            item={activeQuestion}
            isModalOpened={isModalOpened}
            handleToggleModal={handleToggleModal}
            fetchQuestions={fetchQuestions}
          />
        )}
      </Page>
    </>
  );
};

export default PageDepartment;
